import { useMutation } from '@tanstack/react-query';
import api from '../../api';
import { type ApiErrorResponse, type ApiResponse } from '../../types';
import { apiPayloadMapper } from '../../utils';
import { type GenerateDEMRequestPayload } from './types';

// Apis.
export const generateDEMRequest = async (payload: GenerateDEMRequestPayload) =>
  await api.post<GenerateDEMRequestPayload, ApiResponse>(
    '/layers/generate-dem/',
    apiPayloadMapper(payload),
  );

// Hooks.
export const useGenerateDEMRequest = () =>
  useMutation<ApiResponse, ApiErrorResponse, GenerateDEMRequestPayload>({
    mutationFn: generateDEMRequest,
  });
